var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 10,
    viewBox: "0 0 106 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3924_12769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7006 9.17996C12.2206 9.17996 10.3906 7.25996 10.3906 4.72996C10.3906 2.19996 12.2206 0.459961 14.7006 0.459961H19.5106V2.32996H14.7006C13.3006 2.32996 12.2706 3.36996 12.2706 4.82996C12.2706 6.28996 13.2906 7.30996 14.7006 7.30996H19.5106V9.17996H14.7006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5108 9.17984L28.2908 7.11984H24.6108L25.4608 5.66984H27.4308L25.8308 2.97984L22.1708 9.17984H20.0508L25.0008 0.939844C25.2208 0.579844 25.4908 0.339844 25.9008 0.339844C26.3108 0.339844 26.5808 0.579844 26.8008 0.939844L31.7508 9.17984H29.5108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5697 9.17996V7.30996H39.1497C39.8197 7.30996 40.2097 6.95996 40.2097 6.40996C40.2097 5.81996 39.8297 5.48996 39.1497 5.48996H35.1997C33.4897 5.48996 32.4297 4.45996 32.4297 2.97996C32.4297 1.49996 33.4097 0.459961 35.2197 0.459961H41.5297V2.32996H35.2197C34.6897 2.32996 34.3697 2.62996 34.3697 3.16996C34.3697 3.70996 34.7097 4.00996 35.2197 4.00996H39.1397C40.9697 4.00996 41.9597 4.82996 41.9597 6.55996C41.9597 8.05996 41.0397 9.16996 39.1397 9.16996H32.5597L32.5697 9.17996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1719 9.17996V0.459961H51.0919V2.32996H45.0319V7.30996H51.1019V9.17996H43.1719ZM46.1219 5.48996V4.01996H50.7519V5.48996H46.1219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8822 9.17996V7.30996H62.4622C63.1322 7.30996 63.5222 6.95996 63.5222 6.40996C63.5222 5.81996 63.1422 5.48996 62.4622 5.48996H58.5122C56.8022 5.48996 55.7422 4.45996 55.7422 2.97996C55.7422 1.49996 56.7222 0.459961 58.5322 0.459961H64.8422V2.32996H58.5322C58.0022 2.32996 57.6822 2.62996 57.6822 3.16996C57.6822 3.70996 58.0222 4.00996 58.5322 4.00996H62.4522C64.2822 4.00996 65.2722 4.82996 65.2722 6.55996C65.2722 8.05996 64.3522 9.16996 62.4522 9.16996H55.8722L55.8822 9.17996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1609 9.17996V2.32996H65.9609V0.459961H74.2409V2.32996H71.0409V9.17996H69.1709H69.1609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7405 0.459961H84.5605V5.32996C84.5605 8.02996 83.2105 9.29996 79.7705 9.29996C76.3305 9.29996 74.9805 8.02996 74.9805 5.32996V0.459961H76.9105V5.32996C76.9105 6.87996 77.5805 7.45996 79.8205 7.45996C82.0605 7.45996 82.7205 6.86996 82.7205 5.32996V0.459961H82.7405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.832 9.17996V0.459961H90.962C93.472 0.459961 95.282 2.19996 95.282 4.72996C95.282 7.25996 93.472 9.17996 90.962 9.17996H85.832ZM90.962 7.30996C92.382 7.30996 93.412 6.26996 93.412 4.82996C93.412 3.38996 92.382 2.32996 90.962 2.32996H87.692V7.30996H90.962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0695 9.17996V6.00996L94.5195 0.459961H97.0295L100.08 4.30996L103.13 0.459961H105.5L100.94 6.00996V9.17996H99.0695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72 0.33V8.27L6.35 9.64H0.33C0.15 9.64 0 9.49 0 9.31V0.33C0 0.15 0.15 0 0.33 0H7.39C7.57 0 7.72 0.15 7.72 0.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72156 8.27002L6.35156 9.64002V8.43002C6.35156 8.34002 6.42156 8.27002 6.51156 8.27002H7.72156Z",
    fill: "url(#paint0_linear_3924_12769)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3924_12769",
    x1: 7.03156,
    y1: 8.95002,
    x2: 6.34156,
    y2: 8.36002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1B1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B6B6B6",
    stopOpacity: 0.5329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C5C5C5",
    stopOpacity: 0.6561
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DEDEDE",
    stopOpacity: 0.8649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3924_12769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.5,
    height: 9.64,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseBlack);
export default __webpack_public_path__ + "static/media/case-black.83f34f1398de693577154a6668b9af87.svg";
export { ForwardRef as ReactComponent };